import React from 'react';
import { Link } from 'react-router-dom';
import './Cookies.css';

const Cookies = () => {
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="container">
          <Link to="/" className="back-button">← Back</Link>
          <h1 className="page-title">Cookies policy.</h1>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="legal-text">
            <p>
              We use cookies to track anonymised data for third-party applications such as Google Analytics. You can disable cookies in your browser settings, but this may affect the functionality of the website.
            </p>

            <h2>Cookies</h2>
            <p>
              Cookies are small text files that are stored locally on your hard drive. They are used to make the website more user-friendly and to customise it to your needs. Cookies are deleted automatically when you close your browser.
            </p>

            <h2>Web Tracking</h2>
            <p>
              We use cookies to analyse how our website is used. This helps us to improve the website and to provide you with a better user experience. The information we collect is anonymous and includes:
            </p>
            <ul>
              <li>Which search engines you used to find our website</li>
              <li>Which search terms you used</li>
              <li>Which languages you prefer</li>
              <li>From which websites you came to our website</li>
              <li>Which browser and plugins you use</li>
              <li>Which referrer you used</li>
              <li>How long you stayed on our website</li>
              <li>Which pages you visited</li>
              <li>Which pages you entered and exited from</li>
              <li>What cancellation rates you have</li>
              <li>Your IP address</li>
            </ul>
            <p>
              This data is used for statistical purposes only and is separate from Personal Data. It cannot be merged with Personal Data to identify you as an individual.
            </p>

            <h2>Google Analytics</h2>
            <p>
              We use Google Analytics, a web analytics service provided by Google Inc. ("Google"). Google Analytics uses cookies to help us analyse how users use our website. The information generated by the cookie about your use of the website (including your IP address) will be transmitted to and stored by Google on servers in the United States.
            </p>
            <p>
              Google will use this information for the purpose of evaluating your use of the website, compiling reports on website activity for website operators and providing other services relating to website activity and internet usage. Google may also transfer this information to third parties where required to do so by law, or where such third parties process the information on Google's behalf.
            </p>
            <p>
              Google will not associate your IP address with any other data held by Google. You may refuse the use of cookies by selecting the appropriate settings on your browser, however please note that if you do this you may not be able to use the full functionality of this website.
            </p>
            <p>
              By using this website, you consent to the processing of data about you by Google in the manner and for the purposes set out above. You can prevent Google from collecting cookie-generated data relating to your use of the website (including your IP address) and from processing this data by downloading and installing the browser plugin available at the following link: <a href="https://tools.google.com/dlpage/gaoptout?hl" target="_blank" rel="noopener noreferrer">https://tools.google.com/dlpage/gaoptout?hl</a>
            </p>
            <p>
              We have activated IP anonymisation on this website. This means that your IP address will be shortened by Google within the European Union or the European Economic Area before being transmitted to the USA. Only in exceptional cases will the full IP address be transmitted to a Google server in the USA and shortened there.
            </p>

            <h2>Approval or Rejection of Cookies</h2>
            <p>
              You can manage your cookie preferences through your browser settings. You can also opt out of targeted advertising by visiting the following links:
            </p>
            <ul>
              <li><a href="http://www.aboutads.info/choices/" target="_blank" rel="noopener noreferrer">http://www.aboutads.info/choices/</a></li>
              <li><a href="http://www.youronlinechoices.com" target="_blank" rel="noopener noreferrer">http://www.youronlinechoices.com</a></li>
              <li><a href="http://preferences-mgr.trustarc.com/" target="_blank" rel="noopener noreferrer">http://preferences-mgr.trustarc.com/</a> (for EU users: <a href="http://www.youronlinechoices.eu/" target="_blank" rel="noopener noreferrer">http://www.youronlinechoices.eu/</a>)</li>
            </ul>
            <p>
              Please note that if you opt out of targeted advertising, you will still see advertisements, but they will not be tailored to your interests. Essential cookies that are necessary for the website to function cannot be refused, but you can block or delete them through your browser settings.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Cookies;
